import React, { CSSProperties } from 'react'
import './Modal.scss'
import { useTranslation } from 'react-i18next'

interface IProps {
  /** Modal is visible */
  visible?: boolean

  /** On close button was pressed */
  onClose: () => void

  /** Content of modal window */
  children: React.ReactNode

  /** Content is loading */
  loading?: boolean

  /** Content of modal footer */
  footer?: React.ReactNode

  /** Title */
  title?: string

  /** Icon */
  icon?: string

  /** Custom styles */
  style?: CSSProperties

  /** Close icon is hidden. False by default. */
  hideCloseIcon?: boolean
}

export const Modal = (props: IProps) => {
  const { t } = useTranslation()

  const header = (!!props.icon || !!props.title) && (
    <div className="box-title relative">
      <span>
        <i className={props.icon}></i>
        {props.title}
      </span>

      <button title={t('CLOSE').toString()} onClick={props.onClose}>
        <i className="icon-close" />
      </button>
    </div>
  )

  const closeIcon = !props.hideCloseIcon && (
    <div className="relative">
      <button title={t('CLOSE').toString()} onClick={props.onClose}>
        <i className="icon-close" />
      </button>
    </div>
  )

  return (
    props.visible && (
      <div className={`modal-background`} style={props.style} onClick={() => props.onClose()}>
        <div className="modal-body" onClick={(e) => e.stopPropagation()}>
          {header}
          {!props.icon && !props.title && closeIcon}
          <div className="modal-box">{!props.loading && <div>{props.children}</div>}</div>
          {!!props.footer && (
            <div className="modal-box" style={{ zIndex: '1' }}>
              {props.footer}
            </div>
          )}
        </div>
      </div>
    )
  )
}
